module.exports = __webpack_public_path__ + "f4404720ece11355df318a0acf525cb1.gif";